import React from 'react'

const TrashIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            {...props}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.5 15.0001H14.1667M14.1667 15.0001H27.5M14.1667 15.0001V26.6667C14.1667 27.1088 14.3423 27.5327 14.6548 27.8453C14.9674 28.1578 15.3913 28.3334 15.8333 28.3334H24.1667C24.6087 28.3334 25.0326 28.1578 25.3452 27.8453C25.6577 27.5327 25.8333 27.1088 25.8333 26.6667V15.0001H14.1667ZM16.6667 15.0001V13.3334C16.6667 12.8914 16.8423 12.4675 17.1548 12.1549C17.4674 11.8423 17.8913 11.6667 18.3333 11.6667H21.6667C22.1087 11.6667 22.5326 11.8423 22.8452 12.1549C23.1577 12.4675 23.3333 12.8914 23.3333 13.3334V15.0001M18.3333 19.1667V24.1667M21.6667 19.1667V24.1667"
                stroke="#667085"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>

    )
}

export default TrashIcon
